const INCREMENT_PROGRESS = 'INCREMENT_PROGRESS'
const DECREMENT_PROGRESS = 'DECREMENT_PROGRESS'
const INCREMENT_MIRROR_PROGRESS = 'INCREMENT_MIRROR_PROGRESS'
const DECREMENT_MIRROR_PROGRESS = 'DECREMENT_MIRROR_PROGRESS'
const SET_PROGRESS = 'SET_PROGRESS'
const SET_NAME = 'SET_NAME'
const SET_SECTION_LENGTH = 'SET_SECTION_LENGTH'
const SET_CURRENT_SECTION = 'SET_CURRENT_SECTION'
const SET_USER_GENDER = 'SET_USER_GENDER'
const SET_USER_AGE = 'SET_USER_AGE'
const START_INTERSTITIAL = 'START_INTERSTITIAL'
const END_INTERSTITIAL = 'END_INTERSTITIAL'
const SET_USER_TOKEN = 'SET_USER_TOKEN'
const SET_GLOBAL_ID = 'SET_GLOBAL_ID'
const SET_RESPONSE_COMPLETE = 'SET_RESPONSE_COMPLETE'
const RES_COMPLETE = 'RES_COMPLETE'
const DYNAMICALLY_SET_SECTION_LENGTH = 'DYNAMICALLY_SET_SECTION_LENGTH'
const INCREMENT_TOTAL_PROGRESS = 'INCREMENT_TOTAL_PROGRESS'
const DECREMENT_TOTAL_PROGRESS = 'DECREMENT_TOTAL_PROGRESS'
const SET_GLOBAL_PROGRESS = 'SET_GLOBAL_PROGRESS'
const SET_TOTAL_QUESTIONS = 'SET_TOTAL_QUESTIONS'
const TOGGLE_MOVING_FORWARD = 'TOGGLE_MOVING_FORWARD'
const TRIGGER_GLOBAL_UNMOUNT = 'TRIGGER_GLOBAL_UNMOUNT'
const REVEAL_OR_HIDE_PROGRESS = 'REVEAL_OR_HIDE_PROGRESS'
const TOGGLE_NAME_GREETING = 'TOGGLE_NAME_GREETING'
const SET_SHOW_BACK_BUTTON = 'SET_SHOW_BACK_BUTTON'
const SET_QUIZ_MOUNTED = 'SET_QUIZ_MOUNTED'
const SET_SUBSCRIPTION_ID = 'SET_SUBSCRIPTION_ID'
const SET_CUSTOMER_ID = 'SET_CUSTOMER_ID'
const SET_EMAIL_CAPTURE = 'SET_EMAIL_CAPTURE'
const SET_IS_MHMD = 'SET_IS_MHMD'
const SET_MHMD_STATE = 'SET_MHMD_STATE'
const SET_MHMD_OPTED = 'SET_MHMD_OPTED'
const SET_HEADER_VARIANT = "SET_HEADER_VARIANT"
const DEVMODE = process.env.GATSBY_DEVMODE === "1"

export const incrementProgress = (newProgress) => {
  return {
    type: INCREMENT_PROGRESS,
    payload: newProgress,
  }
}

export const decrementProgress = (newProgress) => {
  return {
    type: DECREMENT_PROGRESS,
    payload: newProgress,
  }
}

export const setProgress = (newProgress) => {
  return {
    type: SET_PROGRESS,
    payload: newProgress,
  }
}

export const setName = (name) => {
  return {
    type: SET_NAME,
    payload: name,
  }
}

export const setSectionLength = (length) => {
  return {
    type: SET_SECTION_LENGTH,
    payload: length,
  }
}

export const setCurrentSection = (name) => {
  const payload = name.split('/').filter(Boolean).pop()
  // eslint-disable-next-line no-console
  DEVMODE && console.log("setCurrentSection", payload)
  return {
    type: SET_CURRENT_SECTION,
    payload
  }
}

export const setUserGender = (gender) => {
  return {
    type: SET_USER_GENDER,
    payload: gender,
  }
}

export const setUserAge = (age) => {
  return {
    type: SET_USER_AGE,
    payload: age,
  }
}

export const startInterstitial = () => {
  return {
    type: START_INTERSTITIAL,
    payload: true,
  }
}

export const endInterstitial = () => {
  return {
    type: END_INTERSTITIAL,
    payload: false,
  }
}

export const setUserToken = (token) => {
  return {
    type: SET_USER_TOKEN,
    payload: token,
  }
}

export const setGlobalId = (id) => {
  return {
    type: SET_GLOBAL_ID,
    payload: id,
  }
}

export const setResponseComplete = () => {
  return {
    type: SET_RESPONSE_COMPLETE,
    payload: true,
  }
}

export const setResultsResponseComplete = () => {
  return {
    type: RES_COMPLETE,
    payload: true,
  }
}

export const dynamicallySetSectionLength = (section, length) => {
  return {
    type: DYNAMICALLY_SET_SECTION_LENGTH,
    payload: {
      section: section,
      length: length,
    },
  }
}

export const incrementTotalProgress = () => {
  return {
    type: INCREMENT_TOTAL_PROGRESS,
  }
}

export const decrementTotalProgress = () => {
  return {
    type: DECREMENT_TOTAL_PROGRESS,
  }
}

export const setGlobalProgress = (prog) => {
  return {
    type: SET_GLOBAL_PROGRESS,
    payload: prog,
  }
}

export const setTotalQuestions = (total) => {
  return {
    type: SET_TOTAL_QUESTIONS,
    payload: total,
  }
}

export const toggleMovingForward = (bool) => {
  return {
    type: TOGGLE_MOVING_FORWARD,
    payload: bool,
  }
}

export const triggerGlobalUnmount = (bool) => {
  return {
    type: TRIGGER_GLOBAL_UNMOUNT,
    payload: bool,
  }
}

export const revealOrHideProgress = (bool) => {
  return {
    type: REVEAL_OR_HIDE_PROGRESS,
    payload: bool,
  }
}

export const incrementMirrorProgress = (newProgress) => {
  return {
    type: INCREMENT_MIRROR_PROGRESS,
    payload: newProgress,
  }
}

export const decrementMirrorProgress = (newProgress) => {
  return {
    type: DECREMENT_MIRROR_PROGRESS,
    payload: newProgress,
  }
}

export const toggleNameGreeting = (bool) => {
  return {
    type: TOGGLE_NAME_GREETING,
    payload: bool,
  }
}

export const setShowBackBtn = (bool) => {
  return {
    type: SET_SHOW_BACK_BUTTON,
    payload: bool,
  }
}

export const setQuizMounted = (bool) => {
  return {
    type: SET_QUIZ_MOUNTED,
    payload: bool,
  }
}

export const setSubscriptionId = (subscription_id) => {
  return {
    type: SET_SUBSCRIPTION_ID,
    payload: subscription_id,
  }
}

export const setCustomerId = (customer_id) => {
  return {
    type: SET_CUSTOMER_ID,
    payload: customer_id,
  }
}

export const setEmailCapture = (bool) => {
  return {
    type: SET_EMAIL_CAPTURE,
    payload: bool,
  }
}

export const setIsMhmd = (bool) => {
  return {
    type: SET_IS_MHMD,
    payload: bool,
  }
}

export const setMhmdState = (location) => {
  return {
    type: SET_MHMD_STATE,
    payload: location,
  }
}

export const setMhmdOpted = (bool) => {
  return {
    type: SET_MHMD_OPTED,
    payload: bool,
  }
}

export const setHeaderVariant = (bool) => {
  return {
    type: SET_HEADER_VARIANT,
    payload: bool,
  }
}